import { Directive } from '@angular/core';

import { ItemComponentBase } from '../../ItemComponentBase';
import { ItemResultRenderTarget, ItemResultRenderTargetComponents } from './item-result-layout/render-targets/ItemResultRenderTarget';

@Directive()
export abstract class ItemResultLayoutComponentsProviderComponentBase extends ItemComponentBase {
  protected readonly LayoutTargets = ItemResultRenderTarget;
  protected readonly LayoutComponents = ItemResultRenderTargetComponents;
}
